import {connect} from 'react-redux';
import Subscription from '../../components/Subscription';
import {subscribe} from '../../actions';
import {State} from '../../reducers';
import {bindActionCreators, Dispatch} from 'redux';

function mapStateToProps(state: State) {
  return {
    enabled: !!state.user.isLoggedIn,
    subscribed: state.subscriptions.subscribed,
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  subscribe,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Subscription);
